import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';

import { useQuery } from '@tanstack/react-query';

import UserService from '../Users/apiService';


const EditStylist = () => {
  const [formFields, setFormFields] = useState(fields);

  const { data: users, isLoading } = useQuery({
    queryKey: ['users'],
    queryFn: UserService.getUsers,
  });

  useEffect(() => {
    if (users) {
      const updatedFields = formFields.map(field => {
        if (field.name === 'user_id') {
          return {
            ...field,
            options: users.map(user => ({
              value: user.user_id,
              label: user.display_name 
            }))
          };
        }
        return field;
      });
      setFormFields(updatedFields);
    }
  }, [users]);

  return (
    <EditForm title={"Stylist"} initialValues={initialValues} fields={formFields} loading={isLoading} schema={schema} url={"stylists"}>
      
    </EditForm>
  );
}

export default EditStylist;